var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-icon',{attrs:{"name":_vm.updateColor == '2'?'static/imgs/shoucang_red.png'
  :_vm.updateColor == '3'?'static/imgs/shoucang_black.png':'static/imgs/shoucang_gray.png',"size":"22"},on:{"click":_vm.goCollection}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe0d3cfe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collection/index.vue
// module id = null
// module chunks = 